import SingleSection from "./components/Public/SingleSection.vue";
import SingleItem from "./components/Public/SingleItem.vue";
import TestPass from "./components/Test/TestPass.vue";
import BeforeStart from "./components/Test/BeforeStart.vue";
import TestResult from "./components/Test/TestResult.vue";
import SectionItem from "./components/Public/SectionItem.vue";

const EmptyRoute = {
    render(createElement) {
        return createElement();
    },
};

export const routes = [
    {
        name: 'base-home',
        path: '/base',
        component: EmptyRoute,
    },
    {
        name: 'section',
        path: '/section/:sectionId',
        component: SingleSection,
        props: true
    },
    {
        name: 'item',
        path: '/item/:itemId',
        component: SingleItem,
        props: true,
    },
    {
        name: 'section-detail-item',
        path: '/section-detail-item/:itemId',
        component: SectionItem,
        props: true,
    },
    {
        name: 'base-detail-item',
        path: '/base-detail-item/:itemId',
        component: EmptyRoute,
        props: true,
    },
    {
        name: 'tests-pass',
        path: '/process',
        component: TestPass,
        props: true,
    },
    {
        name: 'before-start',
        path: '/before-start',
        component: BeforeStart,
        props: true,
    },
    {
        name: 'tests-result',
        path: '/result',
        component: TestResult,
        props: true,
    },
];
